const testimonialsContainer = (theme) => ({
  padding: '6rem 1.5rem 9rem 1.5rem',
  borderRadius: '1.25rem 1.25rem 0 0',
  background: `linear-gradient(180deg, ${theme.palette.contrast.A700} 3%, #000000 92%)`,
  width: '100%',
  gap: { xs: '3rem', m: '6.8rem' },
  overflow: 'hidden',
});

const headerStack = {
  display: 'flex',
  flexDirection: 'column',
  width: '80%',
  gap: { xs: '1rem', m: '0.5rem' },
  alignItems: 'center',
  justifyContent: 'center',
};

const headerTypography = {
  color: 'white',
  textAlign: 'center',
};

const carouselContainer = {
  overflow: 'hidden',
  width: '98%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  paddingLeft: { xs: '112rem', phone: '130rem' },
  maxWidth: '80rem',
};

const carouselStack = (currentIndex, isTransitioning) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem',
  transform: {
    xs: `translateX(calc(-${currentIndex} * (15rem + 1rem)))`,
    phone: `translateX(calc(-${currentIndex} * (25rem + 1rem)))`,
  },
  transition: isTransitioning ? 'transform 0.6s ease-out' : 'none',
  alignItems: 'stretch',
});

const navigationButton = {
  position: 'absolute',
  borderRadius: '2.5rem',
  minWidth: 0,
  padding: '1.2rem',
  width: '1.5rem',
  height: '1.5rem',
  zIndex: 2,
  background: 'rgba(255, 255, 255, 0.40)',
  '&:hover': {
    background: 'rgba(255, 255, 255, 0.40)',
  },
  '&:active': {
    transition: 'transform 0.1s ease-in-out',
    transform: 'scale(0.9)',
  },
};

const prevButton = {
  ...navigationButton,
  left: '4rem',
};

const nextButton = {
  ...navigationButton,
  right: '4rem',
};

const iconStyles = {
  objectFit: 'contain',
  color: 'white',
};

export {
  testimonialsContainer,
  headerStack,
  headerTypography,
  carouselContainer,
  carouselStack,
  prevButton,
  nextButton,
  iconStyles,
};
